import { render, staticRenderFns } from "./manage-seats-form.vue?vue&type=template&id=7cdcbfb3&"
import script from "./manage-seats-form.vue?vue&type=script&lang=js&"
export * from "./manage-seats-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports